import { unit, number } from './parsers'

export default ({
  colSpan,
  columns = 12,
  gutter = '10px',
  align = 'left',
  offset = 0,
  gridUseGutters = false
}) => {
  const styles = {}

  if (!isNaN(colSpan) && Math.ceil(colSpan) === colSpan) {
    // Check if $col-span is a valid integer number then process the parameters passed to the grid() mixin.
    styles.boxSizing = 'border-box'
    const initColWidth = colSpan * 100 / columns
    const newOffset = offset * 100 / columns
    let newGutter

    if (align === 'left') {
      // Check if align is set to left (default) and make element floating to the left
      styles.float = 'left'

      if (!gridUseGutters) {
        // If gridUseGutters is set to false (true by default) set the element width based on the initColWidth process result.
        styles.width = `${initColWidth}%`
      }

      if (offset !== 0 && gutter === 0) {
        // Check if not 0 offset is passed as argument and then if gutter is 0 set the left (based on direction) margin as offset.
        styles.marginLeft = `${newOffset}%`
      } else if (offset !== 0 && gutter !== 0) {
        // If offset && gutter aren't 0 set the left offset by adding the gutter
        styles.margin = `0 ${gutter} 0 calc(${newOffset}% + ${gutter})`
      }
    } else if (align === 'right') {
      // Check if align is set to right && make element floating to the right
      styles.float = 'right'

      if (!gridUseGutters) {
        // If gridUseGutters is set to false (true by default) set the element width based on the initColWidth process result.
        styles.width = `${initColWidth}%`
      }

      if (offset !== 0 && gutter === 0) {
        // Check if not 0 offset is passed as argument && then if gutter is 0 set the right (based on direction) margin as offset.
        styles.marginRight = `${newOffset}%`
      } else if (offset !== 0 && gutter !== 0) {
        // If offset && gutter aren't set to 0 put the right offset by adding the gutter
        styles.margin = `0 calc(${newOffset}% + ${gutter}) 0 gutter`
      }
    } else if (align === 'center') {
      // Check if align is set to center && make element st&&ing to the center of is parent
      styles.margin = '0 auto'

      if (!gridUseGutters) {
        // If gridUseGutters is false calculate the width based on columns argument
        styles.width = `${initColWidth}%`
      }
    } else {
      // If no additional argument is passed set the default grid style
      styles.float = left

      if (!gridUseGutters) {
        // If gridUseGutters is false calculate the width based on columns argument
        styles.width = `${initColWidth}%`
      }
    }

    if (!!gridUseGutters) {
      // If gridUseGutters is true then calculate the default new width && leftMargin based on columns && colSpan
      newGutter = number(gutter) / (columns / colSpan)

      if (!isNaN(gutter) && unit(gutter) === '%') {
        // if the gutter has a % unit
        styles.width = `${initColWidth - number(gutter) - newGutter}%`

        if (offset === 0) {
          styles.margin = `0 0 0 ${gutter}`
        }
      } else {
        //If the gutter doesn't have a % unit
        styles.width = `calc( ${initColWidth}%  ${gutter}  ${newGutter}${unit(
          gutter
        )} )`

        if (offset === 0) {
          styles.margin = `0 0 0 ${gutter}`
        }
      }
    }
  } else if (colSpan === 'none') {
    // If the first argument ($colSpan) is set to 'none' remove all grid style && floatings
    styles.float = 'none'
    styles.width = 'auto'
    styles.margin = 'auto'
  }

  return styles
}



// WEBPACK FOOTER //
// ./styles/tools/grid.js